import { useAsync, useDebounce } from 'react-use';

import {
  configApiRef,
  microsoftAuthApiRef,
  useApi,
} from '@backstage/core-plugin-api';
import { useTemplateSecrets } from '@backstage/plugin-scaffolder-react';

import { kaapApiRef } from '../api/KaapApiClient';

export const KAAP_API_TOKEN_SECRET_KEY = 'KAAP_API_TOKEN';

/**
 * Silently acquires an Azure token scoped to the KaaP API (`${kaap.apiUrl}/.default`)
 * and stores it under `secrets.KAAP_API_TOKEN` so scaffolder steps can use it.
 * Must be called from within the scaffolder's secrets context.
 */
export const useKaapAzureToken = () => {
  const config = useApi(configApiRef);
  const microsoftAuth = useApi(microsoftAuthApiRef);
  const { setSecrets } = useTemplateSecrets();

  const scope = `${config.getString('kaap.apiUrl')}/.default`;

  useDebounce(async () => {
    const token = await microsoftAuth.getAccessToken(scope);
    if (token) {
      setSecrets({ [KAAP_API_TOKEN_SECRET_KEY]: token });
    }
  }, 1000);
};

export const useGetKaapClusters = () => {
  const kaapApi = useApi(kaapApiRef);
  const { value, loading, error } = useAsync(
    () => kaapApi.getClusters(),
    [kaapApi],
  );
  return { value, loading, error };
};

export const useGetKaapApplications = () => {
  const kaapApi = useApi(kaapApiRef);
  const { value, loading, error } = useAsync(
    () => kaapApi.getApplications(),
    [kaapApi],
  );
  return { value, loading, error };
};
